(function () {
  'use strict';

  angular.module('wsLrs.controllers').factory("Interactions", ['Api', 'CardQueryResource', 'Logger', function (Api, CardQueryResource, Logger) {
    var basePath = "/interactions";
    var hasAnyCache = {};
    var srvc = {
      count: function count(params, isPreview) {
        return CardQueryResource.get({
          path: basePath + (isPreview ? "/count/preview" : "/count"),
          params: params
        }).then(function (response) {
          return response.data.count;
        });
      },
      hasAny: function hasAny() {
        var cacheKey = Api.url();
        if (!hasAnyCache[cacheKey]) {
          hasAnyCache[cacheKey] = srvc.count().then(function (count) {
            return count > 0;
          }, function (err) {
            Logger.warn(err);
            return false;
          });
        }
        return hasAnyCache[cacheKey];
      },
      get: function get(params, isPreview, alternateBasePath) {
        var path = basePath + (isPreview ? "/preview" : "");
        if (alternateBasePath) {
          path = alternateBasePath;
        }
        return CardQueryResource.get({
          path: path,
          params: params
        }).then(function (response) {
          return response.data.results[0].result;
        });
      }
    };
    return srvc;
  }]);
})();
